import MediaListing from './MediaListing';
import {Provider} from './MediaContext';

const Media = (props) => {
  return (
    <Provider>
      <MediaListing {...props} />
    </Provider>
  );
};

export default Media;
